import { ShieldCheck } from "lucide-react";

export function Brand({ size = "md", className = "" }) {
  const dim = size === "lg" ? "h-11 w-11" : size === "sm" ? "h-8 w-8" : "h-9 w-9";
  const text = size === "lg" ? "text-2xl" : size === "sm" ? "text-lg" : "text-xl";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="vp-brand">
      <div className={`${dim} grid place-items-center rounded-xl bg-gradient-to-br from-emerald-400 to-cyan-500 text-[#08120e] shadow-lg shadow-emerald-500/25`}>
        <ShieldCheck className="h-1/2 w-1/2" strokeWidth={2.5} />
      </div>
      <span className={`font-display font-extrabold tracking-tight ${text}`}>
        Vantor<span className="text-emerald-400">Pay</span>
        <span className="text-slate-500 font-medium text-xs align-super">.com</span>
      </span>
    </div>
  );
}
